import type { UseTranslationResponse } from 'react-i18next';
import { useTranslation } from 'react-i18next';

const namespace = 'entities';
export const keyPrefix = 'verify_face_form';
export const useVerifyFaceFormTranslation = (): UseTranslationResponse<typeof namespace, typeof keyPrefix> => {
  return useTranslation(namespace, { keyPrefix });
};

export const ruRu = ({
  [keyPrefix]: {
    modal_title: 'Сравнить лица',
    verify_button: 'Сравнить',
    clear_button: 'Очистить',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    modal_title: 'Compare faces',
    verify_button: 'Compare',
    clear_button: 'Clear',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    modal_title: 'Comparar faces',
    verify_button: 'Comparar',
    clear_button: 'Limpar',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    modal_title: 'Comparar caras',
    verify_button: 'Comparar',
    clear_button: 'Limpiar',
  },
}) as Record<string, unknown>;
